/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'time-frame-selector';
const prefix = `${moduleName}.${componentName}`;

export const displayingLabel = `${prefix}.displayingLabel`;

export const ENGLISH = {
    [displayingLabel]: 'Displaying',
};
